import { useLayoutEffect, useEffect, useRef } from 'react';
import log from '../utility/debug.js';
export default function useVirtualScrollerStartStop(virtualScroller, _ref) {
  var readyToStart = _ref.readyToStart;
  var hasStarted = useRef(false);

  var startIfReadyToStartAndNotStarted = function startIfReadyToStartAndNotStarted() {
    if (!hasStarted.current) {
      if (readyToStart === false) {
        log('Could\'ve started but isn\'t ready to start');
      } else {
        hasStarted.current = true; // Start listening to scroll events.

        virtualScroller.start();
      }
    }
  };

  var stopIfStarted = function stopIfStarted() {
    if (hasStarted.current) {
      // Stop listening to scroll events.
      virtualScroller.stop(); // Can be re-started.

      hasStarted.current = false;
    }
  }; // Uses `useLayoutEffect()` here rather than just `useEffect()`
  // in order to reduce the timeframe of showing an empty list to the user.


  useLayoutEffect(function () {
    startIfReadyToStartAndNotStarted();
    return stopIfStarted;
  }, []);
  var readyToStartPrev = useRef(readyToStart);
  useEffect(function () {
    if (readyToStartPrev.current === false && readyToStart !== false) {
      readyToStartPrev.current = readyToStart;
      log('Is ready to start');
      startIfReadyToStartAndNotStarted();
    }
  }, [readyToStart]);
}
//# sourceMappingURL=useStartStopVirtualScroller.js.map